import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { DirectiveModule, FinFormsModule, ImagesModule, PipesModule } from '@fcom/common';
import { FcomFormsModule } from '@fcom/ui-components';
import { CmsModule } from '@fcom/cms';
import { UiTranslateModule } from '@fcom/ui-translate';
import { UiComponentsModule } from '@fcom/ui-components/ui-components.module';
import { OrderModule } from '@fcom/order';
import { ComponentsModule } from '@fcom/common/components/components.module';
import { LoginModule } from '@fcom/common/login';

import { PNR_WIDGET_FEATURE_KEY } from './interfaces/store.interface';
import { PnrWidgetComponent } from './components/pnr-widget/pnr-widget.component';
import { UpcomingTripsComponent } from './components/upcoming-trips/upcoming-trips.component';
import { UpcomingTripComponent } from './components/upcoming-trip/upcoming-trip.component';
import { reducers } from './store';
import { UpcomingTripsEffects } from './store/effects/upcoming-trips.effects';

@NgModule({
  declarations: [PnrWidgetComponent, UpcomingTripsComponent, UpcomingTripComponent],
  exports: [PnrWidgetComponent, UpcomingTripsComponent, UpcomingTripComponent],
  imports: [
    CommonModule,
    DirectiveModule,
    ImagesModule,
    LoginModule,
    PipesModule,
    UiTranslateModule,
    UiComponentsModule,
    ComponentsModule,
    FcomFormsModule,
    CmsModule,
    FinFormsModule,
    OrderModule,
    StoreModule.forFeature(PNR_WIDGET_FEATURE_KEY, reducers),
    EffectsModule.forFeature([UpcomingTripsEffects]),
  ],
})
export class PnrWidgetModule {}
